import {useMediaQuery, useTheme} from '@mui/material';
import type {Breakpoint} from '@mui/material';

/**
 * Returns whether the viewport is at or below `breakpoint`, meaning callers
 * (e.g. `ImagePreviewModal`) should render a full-screen mobile layout.
 * Omit `breakpoint` to always return `false`.
 *
 * `useMediaQuery` is always invoked with a concrete breakpoint (hooks can't
 * be called conditionally); when `breakpoint` is omitted we fall back to
 * `'xs'` internally and simply discard the match via the `Boolean(breakpoint)`
 * guard, keeping the hook's call shape stable across renders regardless of
 * whether a breakpoint is provided.
 */
export const useFullScreenBreakpoint = (breakpoint?: Breakpoint): boolean => {
  const theme = useTheme();
  const matchesBreakpoint = useMediaQuery(theme.breakpoints.down(breakpoint ?? 'xs'));
  return Boolean(breakpoint) && matchesBreakpoint;
};


